import { createFileRoute } from "@tanstack/react-router";
import { DocumentSecurityPage } from "@client/components/admin/share-governance/share-governance-page";

export const Route = createFileRoute("/_app/tenant-settings/document-security")({
  component: DocumentSecurityRoutePage,
});

function DocumentSecurityRoutePage() {
  return (
    <div className="grid gap-6 p-6">
      <DocumentSecurityPage />
    </div>
  );
}
